module.exports = __webpack_public_path__ + "img/17_47.a9565a84.png";